<template>
    <svg focusable="false" class="icon search-icon" width="31px" height="32px" viewBox="0 0 31 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>icon-search</title>
        <desc>Created with Sketch.</desc>
        <g class="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g class="cmhr-edu-resource-toolkit-01B-landing-2.0" transform="translate(-221.000000, -388.000000)" stroke="#232323">
                <g class="intro" transform="translate(0.000000, 174.000000)">
                    <g class="search-field">
                        <g class="icon-search" transform="translate(223.000000, 216.000000)">
                            <g>
                                <circle class="Oval" stroke-width="2.22222222" cx="10.2631579" cy="10.2631579" r="10.2631579"></circle>
                                <path d="M17.3684211,18.9473684 L26.8421053,28.4210526" class="Line-3" stroke-width="2.22222222"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style scoped lang="scss">
    svg {
        height: 30px;
        width: 28px;
    }
</style>

<script>
    export default {
        name: "SearchIcon"
    }
</script>